import React, {useEffect, useState} from 'react';

import './index.less';

const DocGoodAt = function (props) {
  const {data} = props;
  const [expand, setExpand] = useState(false);

  const onToggle = () => {
    setExpand(!expand);
  };

  return (
    <article className="doc-block">
      <div className="doc-block-header" onClick={onToggle}>
        <span className="tit">专业擅长</span>
        <span className="arrow">
          {expand ? '收起' : '展开'}
          <i className={`iconfont color-BFB59E${expand ? ' iconfont-arr-down' : ' iconfont-arr-right'}`} />
        </span>
      </div>
      <div className={expand ? '' : 'text-flow-ellipsis-multiple line4'}>
        {data &&
          data.map((item, idx) => {
            return (
              <span key={idx} data-disease-id={item.disease_id} className="global-label-text">
                {item.disease_name}
              </span>
            );
          })}
      </div>
    </article>
  );
}

export default DocGoodAt;
